import React, { useState, useEffect, useRef } from "react";
import styles from "./tooltip.module.css";
import { isMobile } from "../../../../helpers/mobile";

const MarkerTooltip = ({ marker, onClick }) => {
    const [tooltipPoint, setTooltipPoint] = useState({ x: 0, y: 0 });
    const [tooltipDisplay, setTooltipDisplay] = useState("none");
    const tooltipRef = useRef();
    const [isMobileDevice] = useState(isMobile());

    useEffect(() => {
        let addToTop = 28;
        if (tooltipRef.current) {
            const currentDisplay = tooltipRef.current.style.display;
            if (currentDisplay === "none") {
                tooltipRef.current.style.display = "block";
            }
            addToTop = tooltipRef.current.offsetHeight;
            if (currentDisplay === "none") {
                tooltipRef.current.style.display = "none";
            }
        }
        setTooltipPoint({
            x: parseInt(marker.x) - 70,
            y: parseInt(marker.y) - (107 + addToTop),
        });
    }, [marker.x, marker.y]);

    useEffect(() => {
        setTooltipDisplay(marker.show ? "block" : "none");
    }, [marker.show]);

    const handleClick = () => {
        console.log("click");

        if (isMobileDevice) {
            console.log("click");
            onClick();
        }
    };

    return (
        <div
            ref={tooltipRef}
            className={styles.tooltipPoint}
            style={{
                display: tooltipDisplay,
                top: `${tooltipPoint.y}px`,
                left: `${tooltipPoint.x}px`,
            }}
        >
            {isMobileDevice && (
                <div className={styles.tooltipIcon}>
                    <ShareIcon />
                </div>
            )}
            <div className={styles.toolBlock} onTouchStart={handleClick}>{marker.title}</div>
        </div>
    );
};

const ShareIcon = () => (
    <svg
        class="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 24 24"
    >
        <path
            stroke="#39adc8"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"
        />
    </svg>
);

export default MarkerTooltip;
